import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import pt from "vuetify/es5/locale/pt"

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#08468E",
        secondary: "#B6DCEF",
        accent: "#F2F2F2",
        error: "#F24130",
        info: "#0540F2",
        success: "#02732A",
        warning: "#f2b204",
        background: "",
        header: "0056B9",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "mdi", // default - only for display purposes
  },
})
